module.exports = __webpack_public_path__ + "img/theme_light.e765f4e4.svg";